import React from "react";

import Button, { ButtonTypes } from "../../../../components/Button";
import { SearchInput } from "../../../../components/Input";
import {
  Toolbar,
  ToolbarCount,
  ToolbarField,
  ToolbarSearch,
  ToolbarSelect,
} from "../../styles";
import { ACTION_GROUPS, ACTION_LABELS, PERIOD_OPTIONS } from "../constants";
import {
  ActivityActionFilter,
  ActivityPeriodFilter,
  ActivityToolbarProps,
} from "../types";

export const ActivityToolbar: React.FC<ActivityToolbarProps> = ({
  query,
  action,
  period,
  isFiltered,
  countLabel,
  onQueryChange,
  onActionChange,
  onPeriodChange,
  onClearFilters,
}) => {
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) =>
    onQueryChange(event.target.value);
  const handleClearSearch = () => onQueryChange("");
  const handleAction = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onActionChange(event.target.value as ActivityActionFilter);
  const handlePeriod = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onPeriodChange(event.target.value as ActivityPeriodFilter);

  return (
    <Toolbar>
      <ToolbarSearch>
        <SearchInput
          aria-label="Search activity"
          placeholder="Symbol, admin or ID"
          value={query}
          onChange={handleSearch}
          onClear={handleClearSearch}
        />
      </ToolbarSearch>
      <ToolbarField>
        Action
        <ToolbarSelect value={action} onChange={handleAction}>
          <option value="all">All actions</option>
          {ACTION_GROUPS.map(({ label, actions }) => (
            <optgroup key={label} label={label}>
              {actions.map((value) => (
                <option key={value} value={value}>
                  {ACTION_LABELS[value]}
                </option>
              ))}
            </optgroup>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      <ToolbarField>
        Date
        <ToolbarSelect value={period} onChange={handlePeriod}>
          {PERIOD_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      {isFiltered && (
        <Button type={ButtonTypes.link} size="small" onClick={onClearFilters}>
          Clear filters
        </Button>
      )}
      {countLabel && <ToolbarCount role="status">{countLabel}</ToolbarCount>}
    </Toolbar>
  );
};
